import React from 'react'

function Spinner() {
  return (
    <div className="loaderWrap" style={{ display: 'none' }}>
      <div className="loader">
        <div className="spinner-circle" />
        <span>Trwa ładowanie...</span>
      </div>
    </div>
  )
}

export default Spinner
